import React, { useContext } from "react";
import { buyNowContext, recipientType } from "../BuyNow";
import mailChimpApi, { MAIL_CHIMP_LIST_IDS, MAIL_CHIMP_TAGS } from "../../../../api/mailChimpApi";
import { PURCHASE_FLOWS } from "../../../../constants";

const GiftForm = ({ validator }) => {
  const { giftSenderInformation, setGiftSenderInformation, purchaseFlow } = useContext(buyNowContext);

  return (
    <>
      { giftSenderInformation.isGift &&
        <>
          <div className="row align-items-center ms-0 p-1">
            <p className="col-12 col-lg-auto plan-main-txt fw-bolder text-dark p-0 mb-0 me-3">Send gift confirmation email to:</p>
            <div className="col d-flex px-2">
              <div className="form-check px-3">
                <input
                  id="gift-email-confirmation-me"
                  name="giftEmailConfirmation"
                  className="form-check-input form-check-input-radio"
                  type="radio"
                  checked={giftSenderInformation.giftConfirmationEmail === recipientType.me}
                  onChange={() => setGiftSenderInformation({...giftSenderInformation, giftConfirmationEmail: recipientType.me})}
                />
                <label className="form-check-label custom-radio-control-label ms-0" htmlFor="gift-email-confirmation-me">
                  <p className="plan-main-txt fw-bolder text-dark pb-0 mb-0">Me</p>
                </label>
              </div>
              <div className="form-check px-3">
                <input
                  id="gift-email-confirmation-recipient"
                  name="giftEmailConfirmation"
                  className="form-check-input form-check-input-radio"
                  type="radio"
                  checked={giftSenderInformation.giftConfirmationEmail === recipientType.recipient}
                  onChange={() => setGiftSenderInformation({...giftSenderInformation, giftConfirmationEmail: recipientType.recipient})}
                />
                <label className="form-check-label custom-radio-control-label ms-0" htmlFor="gift-email-confirmation-recipient">
                  <p className="plan-main-txt fw-bolder text-dark p-0 m-0">Me and my recipient</p>
                </label>
              </div>
            </div>
          </div>
          <div className="row g-2 mt-0 mb-2">
            <div className="col-12 col-lg-6">
                  <textarea
                    className="form-control form-control-inputs"
                    placeholder="Add an optional gift message"
                    value={giftSenderInformation.message}
                    onChange={e => { setGiftSenderInformation({...giftSenderInformation, message: e.target.value}) }}
                  />
            </div>
            <div className="d-none d-lg-block col-lg-6"/>
            <div className="col-md-6">
              <input
                type="text"
                id="giftInputName"
                name="giftFullName"
                className="form-control form-control-inputs"
                placeholder="Your name"
                value={giftSenderInformation.name}
                onChange={e => { setGiftSenderInformation({...giftSenderInformation, name: e.target.value}) }}
              />
              {validator.message('name', giftSenderInformation.name, 'required')}
            </div>
            <div className="col-md-6">
              <input
                type="email"
                id="giftEmailAddress"
                name="giftEmailAddress"
                className="form-control form-control-inputs"
                placeholder="Your email address"
                value={giftSenderInformation.email}
                onChange={e => { setGiftSenderInformation({...giftSenderInformation, email: e.target.value}) }}
                onBlur={() => {
                  if (purchaseFlow === PURCHASE_FLOWS.SHAPA_END_USER)
                    mailChimpApi.saveEmailAddressToList(giftSenderInformation.email, MAIL_CHIMP_LIST_IDS.SHAPA_SUBSCRIBERS_LIST, MAIL_CHIMP_TAGS.ABANDONED_CART_TAG)
                }}
              />
              {validator.message('giftEmailAddress', giftSenderInformation.email, 'required|email')}
            </div>
          </div>
        </>
      }
    </>
  );
};

export default GiftForm;
